{
  "en": {
    "topicAnalysisPlans": {
      "submitDocumentsForAnalysisSuccess": "Documents submitted successfully.",
      "submitDocumentsForAnalysisError": "Failed to submit documents.",
      "validateTopicsSuccess": "Topics validated successfully.",
      "validateTopicsError": "Failed to validate topics.",
      "deleteTopicsSuccess": "Topics deleted successfully.",
      "deleteTopicsError": "Failed to delete topics.",
      "validateTopicSuccess": "Topic validated successfully.",
      "validateTopicError": "Failed to validate topic."
    }
  },
  "fr": {
    "topicAnalysisPlans": {
      "submitDocumentsForAnalysisSuccess": "Documents soumis avec succès.",
      "submitDocumentsForAnalysisError": "Échec de la soumission des documents.",
      "validateTopicsSuccess": "Avis validés avec succès.",
      "validateTopicsError": "Échec de la validation des avis.",
      "deleteTopicsSuccess": "Avis supprimés avec succès.",
      "deleteTopicsError": "Échec de la suppression des avis.",
      "validateTopicSuccess": "Avis validé avec succès.",
      "validateTopicError": "Échec de la validation de l'avis."
    }
  },
  "nl": {
    "topicAnalysisPlans": {
      "submitDocumentsForAnalysisSuccess": "Documenten succesvol ingediend.",
      "submitDocumentsForAnalysisError": "Indienen van documenten mislukt.",
      "validateTopicsSuccess": "Onderwerpen succesvol gevalideerd.",
      "validateTopicsError": "Valideren van onderwerpen mislukt.",
      "deleteTopicsSuccess": "Onderwerpen succesvol verwijderd.",
      "deleteTopicsError": "Verwijderen van onderwerpen mislukt.",
      "validateTopicSuccess": "Onderwerp succesvol gevalideerd.",
      "validateTopicError": "Valideren van onderwerp mislukt."
    }
  }
}
